import type {DomainCountry} from 'src/common/types'

import type {SubmitEmailData} from './types'

export type FraudGameHubspotFields = {
  firstname: string
  lastname: string
  company: string
  email: string
  billing_country: string
}

const HUBSPOT_BILLING_COUNTRY_BY_DOMAIN_COUNTRY: Partial<Record<DomainCountry, string>> = {
  at: 'Austria',
  de: 'Germany',
  eu: 'Germany',
  gb: 'United Kingdom',
  nl: 'Netherlands',
}

export const splitFullNameForHubspot = (name: string): {firstname: string; lastname: string} | null => {
  const nameParts = name.trim().split(/\s+/).filter(Boolean)

  if (nameParts.length < 2) {
    return null
  }

  const [firstname, ...lastNameParts] = nameParts

  return {
    firstname,
    lastname: lastNameParts.join(' '),
  }
}

export const getHubspotBillingCountry = (domainCountry: DomainCountry): string =>
  HUBSPOT_BILLING_COUNTRY_BY_DOMAIN_COUNTRY[domainCountry] ?? 'United Kingdom'

export const mapSubmitEmailDataToHubspotFields = (
  data: SubmitEmailData,
  domainCountry: DomainCountry,
): FraudGameHubspotFields | null => {
  const name = splitFullNameForHubspot(data.name)

  if (!name) {
    return null
  }

  return {
    firstname: name.firstname,
    lastname: name.lastname,
    company: data.company,
    email: data.email,
    billing_country: getHubspotBillingCountry(domainCountry),
  }
}
